import React, { Component } from 'react'
import '../App.css'
import User from '../common/User.js'
import { Button, Grid, Row, Col } from 'react-bootstrap'

export default class PageHeader extends Component {
  render () {
    return (
      <div className='PageHeader'>
        <Grid fluid>
          <Row>
            <Col xs={8}>
              <div className='header-content left-align'>
                <span className='header-content-span'>
                  <User uid={this.props.uid} />
                </span>
              </div>
            </Col>
            <Col xs={4}>
              <div className='header-content right-align'>
                <span className='header-content-span'>
                  <Button bsStyle='link' onClick={this.props.onLogoutClicked}>Logout</Button>
                </span>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Header.js